import { render, staticRenderFns } from "./DocumentoLicencasView.vue?vue&type=template&id=2cd63e86"
import script from "./DocumentoLicencasView.vue?vue&type=script&lang=js"
export * from "./DocumentoLicencasView.vue?vue&type=script&lang=js"
import style0 from "./DocumentoLicencasView.vue?vue&type=style&index=0&id=2cd63e86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports